module.exports = __webpack_public_path__ + "img/info-circle.6b4e4989.svg";